// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5740":"1368c94a","7211":"1368c94a","8616":"1368c94a"}[chunkId] + ".chunk.css";
};